import { useEffect, useState } from 'react'

type BaseAutocompleteResult = {
  id: string
  code: string
  name: string
  country_code: string
  country_name: string
  coordinates: {
    lon: number
    lat: number
  }
}

export type CityAutocompleteResult = BaseAutocompleteResult & {
  type: 'city'
  main_airport_name: string | null
}

export type AirportAutocompleteResult = BaseAutocompleteResult & {
  type: 'airport'
}

export type TravelPayoutAutocompleteResult = CityAutocompleteResult | AirportAutocompleteResult

export const getAirportName = (result: TravelPayoutAutocompleteResult): string => {
  if (result.type === 'city' && result.main_airport_name) {
    return result.main_airport_name
  }

  return result.name
}

const useAirportLookup = (term: string, search = true) => {
  const [results, setResults] = useState<TravelPayoutAutocompleteResult[]>([])
  const cleanedTerm = term.trim()

  useEffect(() => {
    if (search && cleanedTerm.length > 2) {
      fetch(`https://autocomplete.travelpayouts.com/places2?term=${cleanedTerm}&locale=en&types[]=airport,city`)
        .then((res) => res.json())
        .then((result) => {
          setResults(result)
        })
    } else {
      reset()
    }
  }, [cleanedTerm, search])

  const reset = () => {
    setResults([])
  }

  return {
    results,
    reset,
    getAirportName,
  }
}

export default useAirportLookup
